import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';

import { QuestionnairesApi } from 'api/QuestionnairesApi';
import { BANK_QUESTIONNAIRES_METADATA_KEY } from '../../keys';
import { useUser } from '../../user';

export function useBankQuestionnairesMetadata() {
  const questionnairesApi = new QuestionnairesApi();
  const { userBankId } = useUser();

  const { data: questionnairesResponse, isLoading: isLoadingBankQuestionnaires } = useQuery({
    enabled: !!userBankId.length,
    queryKey: [BANK_QUESTIONNAIRES_METADATA_KEY, userBankId],
    queryFn: () => questionnairesApi.getQuestionnairesForBank(userBankId, true)
  });

  const allQuestionnaires = questionnairesResponse?.questionnaires;

  const questionnaires = useMemo(
    () => Object.fromEntries(Object.entries(allQuestionnaires ?? {}).filter(([, q]) => !q.archived)),
    [allQuestionnaires]
  );

  return {
    allQuestionnaires,
    questionnaires,
    questionnaireLimit: questionnairesResponse?.questionnaires_allowed ?? 0,
    isLoadingBankQuestionnaires
  };
}
